import subject from './subject/routes'

const FeedbackIndex = () => import('./views/FeedbackIndex.vue')
const FeedbackCreate = () => import('./views/FeedbackCreate.vue')
const FeedbackEdit = () => import('./views/FeedbackEdit.vue')

export default [
  {
    path: 'feedback',
    name: 'feedback.index',
    component: FeedbackIndex
  },
  {
    path: 'feedback/create',
    name: 'feedback.create',
    component: FeedbackCreate
  },
  {
    path: 'feedback/:feedbackId(\\d+)',
    name: 'feedback.edit',
    component: FeedbackEdit
  },
  ...subject
]
